export default {
  "b2b.doplnkova-sluzba-detail.title-placeholder": "Supplementary service",
  "b2b.doplnkova-sluzba-detail.message-empty": "Supplementary service not found"
};
